import { render, staticRenderFns } from "./SaleTicketItems.vue?vue&type=template&id=166c4d16&"
import script from "./SaleTicketItems.vue?vue&type=script&lang=js&"
export * from "./SaleTicketItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports